<template>
  <div>
    <Layout v-if="this.useLayout">
      <router-view />
    </Layout>
    <router-view v-else />
  </div>
</template>

<script>
import Layout from "@/layouts/Layout";

export default {
  computed: {
    useLayout() {
      return this.$store.getters["layout/useLayout"];
    },
  },
  components: {
    Layout,
  },
};
</script>

<style lang="scss"></style>
